module.exports = __webpack_public_path__ + "img/Fahrzeug.007d31d6.svg";